import { ZMetaNode } from "../types/metaTypes";

export const ex1metaTabs = {
  type: "grid",
  items: [
    {
      type: "field",
      name: "actual",
      title: "Актуальный",
      component: { type: "Checkbox" },
    },
    {
      type: "tabs",
      colSpan: "*",
      tabs: [
        {
          key: "1",
          label: "Первая вкладка",
          layout: {
            type: "grid",
            items: [
              {
                type: "field",
                name: "units",
                title: "Единица измерения (кг/ литры/ упк)",
                component: {
                  type: "Select",
                  options: [
                    { value: "kg", label: "кг" },
                    { value: "l", label: "литры" },
                    { value: "pack", label: "упк" },
                  ],
                },
              },
              {
                type: "field",
                name: "unitMass",
                title: "Граммовка ед.товара (вес/ объем/ шт)",
                component: {
                  type: "InputNumber",
                  min: 0,
                },
              },
              {
                type: "field",
                name: "fullName",
                title: "Полное наименование товара (с ед.изм.)",
                component: { type: "Input" },
                rules: [{ type: "required" }],
              },
            ],
          },
        },
        {
          key: "2",
          label: "Вторая вкладка",
          layout: {
            type: "grid",
            items: [
              {
                type: "field",
                name: "commodityCode",
                title: "Код Товарной позиции",
                component: { type: "Input" },
              },
              {
                type: "field",
                name: "comment",
                title: "Комментарий",
                component: { type: "Input" },
                colSpan: 3,
              },
            ],
          },
        },
      ],
    },
    {
      type: "field",
      name: "contracts",
      title: "Договора с поставщиками",
      colSpan: "*",
      component: {
        type: "CollapseList",
        row: {
          layout: {
            type: "grid",
            items: [
              {
                name: "contractType",
                type: "field",
                title: "Вид договора",
                component: { type: "Input" },
              },
              {
                name: "number",
                type: "field",
                title: "Номер",
                component: { type: "Input" },
                rules: [{ type: "pattern", pattern: /^\d*$/.toString() }],
              },
              {
                name: "fullName",
                type: "field",
                title: "Полное название",
                component: { type: "Input" },
              },
            ],
          },
        },
      },
    },
  ] as ZMetaNode[],
} satisfies ZMetaNode;
